import { cn } from "@/lib/utils";

interface BrainstormIndicatorProps {
  phase: string;
  className?: string;
}

const PHASE_LABELS: Record<string, string> = {
  UNDERSTAND: "Understanding your goal",
  PROPOSE: "Proposing approaches",
  PLAN: "Planning the pipeline",
  BUILD: "Building now",
};

export function BrainstormIndicator({
  phase,
  className,
}: BrainstormIndicatorProps) {
  const label = PHASE_LABELS[phase] ?? phase;
  // Startcase it:
  const startCaseLabel = label.charAt(0).toUpperCase() + label.slice(1);
  return (
    <div
      className={cn(
        "mb-2 inline-flex items-center gap-1.5 rounded-full border border-purple-500/30 bg-purple-500/10 px-2.5 py-0.5 text-xs font-medium text-purple-600 dark:text-purple-400",
        className,
      )}
      aria-label={`Brainstorm phase: ${label}`}
    >
      <span className="size-1.5 rounded-full bg-purple-500 animate-pulse" />
      {startCaseLabel}
    </div>
  );
}
